import { useEffect } from "react";

import styled from "styled-components/macro";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import { useGetHomeSettings } from "../../API/queries";
import {
  useGetBackgroundColorData,
  useGetFontData,
} from "../../API/queryHooks";
import { getFontFamily } from "../../constants/fonts";
import "../../shared/MemberPortal.scss";

import AboutSection from "./AboutSection";
import FooterSection from "./FooterSection";
import HeroSection from "./HeroSection";

const HomePage = () => {
  const { isLoading } = useGetHomeSettings();
  const { selectedFont, isLoading: fontLoading } = useGetFontData();
  const { backgroundString } = useGetBackgroundColorData();

  useEffect(function setPageTitle() {
    document.title = "Home";
  }, []);

  const currentFontFamily = getFontFamily(selectedFont);

  return (
    <FnrOpacityToggle show={!isLoading && !fontLoading}>
      <HomePageContainer
        $fontFamily={currentFontFamily}
        $backgroundString={backgroundString}
      >
        <HeroSection />
        <AboutSection />
        <FooterSection />
      </HomePageContainer>
    </FnrOpacityToggle>
  );
};

const HomePageContainer = styled.div`
  font-family: ${({ $fontFamily }) => $fontFamily || '"Open Sans", sans-serif'};
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: ${({ $backgroundString }) => $backgroundString};
`;

export default HomePage;
